export interface MangaArticle {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  content: string[];
  author: string;
  publishDate: string;
  updateDate: string;
  tags: string[];
  views: number;
  rating: number;
}

export interface MangaCategory {
  name: string;
  slug: string;
  icon: string;
  description: string;
  articleCount: number;
}

export interface FAQItem {
  question: string;
  answer: string;
}

export const categories: MangaCategory[] = [
  {
    name: '热血冒险',
    slug: 'rexue-maoxian',
    icon: 'ri-fire-line',
    description: '充满激情与冒险的热血漫画，燃爆你的每一根神经',
    articleCount: 128,
  },
  {
    name: '恋爱校园',
    slug: 'lianai-xiaoyuan',
    icon: 'ri-heart-line',
    description: '甜蜜的校园恋爱故事，青春的悸动与美好回忆',
    articleCount: 96,
  },
  {
    name: '悬疑推理',
    slug: 'xuanyi-tuili',
    icon: 'ri-search-eye-line',
    description: '扣人心弦的悬疑推理漫画，挑战你的智商极限',
    articleCount: 74,
  },
  {
    name: '搞笑日常',
    slug: 'gaoxiao-richang',
    icon: 'ri-emotion-laugh-line',
    description: '轻松搞笑的日常漫画，让你开怀大笑忘却烦恼',
    articleCount: 112,
  },
  {
    name: '科幻奇幻',
    slug: 'kehuan-qihuan',
    icon: 'ri-rocket-line',
    description: '天马行空的科幻奇幻世界，想象力无边无际',
    articleCount: 85,
  },
  {
    name: '古风武侠',
    slug: 'gufeng-wuxia',
    icon: 'ri-sword-line',
    description: '唯美古风与热血武侠的完美融合，尽显东方美学',
    articleCount: 63,
  },
  {
    name: '恐怖灵异',
    slug: 'kongbu-lingyi',
    icon: 'ri-ghost-line',
    description: '惊悚刺激的恐怖灵异漫画，胆小者慎入',
    articleCount: 52,
  },
  {
    name: '治愈温馨',
    slug: 'zhiyu-wenxin',
    icon: 'ri-sun-line',
    description: '温暖治愈的漫画作品，抚慰你疲惫的心灵',
    articleCount: 89,
  },
];

export const articles: MangaArticle[] = [
  {
    id: '1',
    title: '禁漫天官方正版入口 - 最新访问地址汇总',
    slug: 'guanfang-zhengban-rukou',
    category: '使用指南',
    categorySlug: 'shiyong-zhinan',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20digital%20manga%20platform%20website%20interface%20with%20colorful%20comic%20book%20elements%2C%20clean%20Japanese%20manga%20style%20design%2C%20warm%20lighting%2C%20digital%20art%20vibe%2C%20professional%20web%20layout%2C%20soft%20gradient%20background%20with%20manga%20panels%20decorative%20elements%2C%20high%20quality%20UI%20design%2C%20tech%20meets%20anime%20aesthetic&width=800&height=450&seq=manga-official-entry&orientation=landscape',
    description: '本文汇总了禁漫天官方正版的最新入口地址，确保您能够安全、快速访问禁漫天平台，畅享海量漫画资源。我们持续更新地址，建议收藏本页以便随时访问。',
    content: [
      '禁漫天作为国内领先的漫画阅读平台，一直致力于为广大漫画爱好者提供优质的阅读体验。为了确保用户能够安全、稳定地访问平台，我们整理了最新的官方入口信息。',
      '官方正版入口地址：请通过本页面提供的官方链接访问禁漫天平台。我们建议用户只使用官方渠道进入，避免通过不明来源的第三方链接访问，以保障账号安全和阅读体验。',
      '为什么需要关注官方入口？由于网络环境的复杂性，漫画平台可能需要不定期更新访问地址。关注官方渠道可以确保您始终能够顺畅访问禁漫天，不错过任何精彩内容更新。',
      '建议您将本页面添加到浏览器收藏夹，或关注禁漫天的官方社交媒体账号，以便及时获取最新入口信息和平台动态。我们承诺持续维护和更新入口信息，让每位用户都能安心畅享漫画世界。',
      '如果您在访问过程中遇到任何问题，可以查阅本网站的常见问题板块，或通过关于我们页面提供的联系方式与我们取得联系。禁漫天始终与您同在！',
    ],
    author: '禁漫天编辑部',
    publishDate: '2026-08-01',
    updateDate: '2026-08-07',
    tags: ['禁漫天官网入口', '禁漫天最新地址', '官方入口', '漫画平台'],
    views: 158920,
    rating: 4.8,
  },
  {
    id: '2',
    title: '禁漫天注册登录完整教程 - 三步搞定',
    slug: 'zhuce-denglu-jiaocheng',
    category: '使用指南',
    categorySlug: 'shiyong-zhinan',
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20mobile%20app%20registration%20screen%20with%20manga%20theme%2C%20colorful%20anime%20style%20UI%2C%20warm%20and%20inviting%20interface%2C%20Japanese%20comic%20aesthetic%2C%20soft%20pastel%20color%20scheme%2C%20modern%20flat%20design%2C%20user%20friendly%20signup%20form%2C%20cute%20manga%20character%20illustrations%2C%20professional%20app%20design&width=800&height=450&seq=manga-register-tutorial&orientation=landscape',
    description: '本篇教程详细介绍禁漫天的注册和登录流程，只需三步即可完成账号创建。涵盖手机号注册、邮箱注册等多种方式，以及忘记密码的解决方案。',
    content: [
      '注册禁漫天账号非常简单，只需几个步骤就能开启您的漫画之旅。下面我们将详细介绍每种注册方式的具体操作流程。',
      '第一步：访问禁漫天官方入口，点击页面右上角的"注册"按钮，进入注册页面。您会看到多种注册方式供选择：手机号注册、邮箱注册和第三方账号快捷登录。',
      '第二步：根据您选择的注册方式填写相应信息。手机号注册需要输入手机号并获取验证码；邮箱注册需要填写邮箱地址并设置密码。建议使用常用邮箱注册，方便后续找回密码。',
      '第三步：完成信息填写后，阅读并同意用户协议和隐私政策，点击"注册"按钮即可完成账号创建。注册成功后建议立即完善个人资料，包括设置头像和昵称。',
      '如果您已经有账号但忘记了密码，可以点击登录页面的"忘记密码"链接，按照提示通过绑定的手机号或邮箱重置密码。整个过程通常只需要几分钟。',
    ],
    author: '禁漫天编辑部',
    publishDate: '2026-08-02',
    updateDate: '2026-08-06',
    tags: ['禁漫天注册登录', '注册教程', '登录方法', '账号管理'],
    views: 98750,
    rating: 4.7,
  },
  {
    id: '3',
    title: '禁漫天漫画资源分类全解析 - 快速找到你的最爱',
    slug: 'manhua-ziyuan-fenlei',
    category: '内容导览',
    categorySlug: 'neirong-daolan',
    coverImage: 'https://readdy.ai/api/search-image?query=Vibrant%20manga%20book%20collection%20organized%20by%20categories%20on%20colorful%20shelves%2C%20Japanese%20comic%20store%20aesthetic%2C%20warm%20lighting%2C%20organized%20manga%20volumes%20with%20genre%20labels%2C%20clean%20and%20inviting%20atmosphere%2C%20professional%20library%20style%20display%2C%20anime%20merchandise%20background%2C%20high%20quality%20photography&width=800&height=450&seq=manga-categories-overview&orientation=landscape',
    description: '禁漫天拥有海量漫画资源，涵盖热血冒险、恋爱校园、悬疑推理、搞笑日常等八大分类。本文帮你快速了解每个分类的特点，精准找到心仪作品。',
    content: [
      '禁漫天的漫画资源库非常丰富，涵盖了几乎所有主流漫画类型。了解每个分类的特点，可以帮助您更快地找到自己喜欢的漫画作品。',
      '热血冒险类：这是最受欢迎的漫画类型之一，代表作品以激烈的战斗场景、主角成长历程和友情羁绊为核心。如果你喜欢充满激情的故事，这个分类绝对不容错过。',
      '恋爱校园类：以校园为舞台的甜蜜恋爱故事，细腻描绘青春期的悸动与美好。画风通常清新唯美，适合喜欢轻松浪漫氛围的读者。',
      '悬疑推理类：扣人心弦的悬疑剧情和烧脑的推理过程，让你在阅读过程中不断猜测真相。这类漫画往往有着精妙的剧情设计和出人意料的结局。',
      '搞笑日常类：轻松幽默的日常故事，用夸张的表现手法和诙谐的对白逗你开怀大笑。是缓解压力、放松心情的最佳选择。',
      '除此之外，禁漫天还拥有科幻奇幻、古风武侠、恐怖灵异和治愈温馨等多种分类，满足不同读者的多样化需求。每个分类下都有数千部优质漫画等你探索。',
    ],
    author: '禁漫天编辑部',
    publishDate: '2026-08-03',
    updateDate: '2026-08-05',
    tags: ['禁漫天漫画资源', '漫画分类', '内容导览', '漫画推荐'],
    views: 76540,
    rating: 4.6,
  },
  {
    id: '4',
    title: '禁漫天使用教程 - 从零开始玩转漫画平台',
    slug: 'shiyong-jiaocheng',
    category: '使用指南',
    categorySlug: 'shiyong-zhinan',
    coverImage: 'https://readdy.ai/api/search-image?query=Step%20by%20step%20tutorial%20guide%20for%20manga%20reading%20app%2C%20clean%20modern%20interface%20with%20numbered%20instructions%2C%20colorful%20anime%20style%20illustrations%2C%20user%20friendly%20design%2C%20warm%20and%20inviting%20color%20palette%2C%20educational%20content%20display%2C%20professional%20guide%20layout%2C%20soft%20background%20with%20manga%20decorative%20elements&width=800&height=450&seq=manga-usage-tutorial&orientation=landscape',
    description: '全面的禁漫天使用教程，涵盖阅读设置、书架管理、离线下载、评论互动等核心功能。无论新手还是老用户，都能从中发现实用技巧。',
    content: [
      '禁漫天提供了丰富而强大的功能，本教程将带你全面了解平台的核心功能，帮助你获得最佳的漫画阅读体验。',
      '阅读设置：在阅读漫画时，你可以根据个人习惯调整阅读模式（左右翻页或上下滚动）、画面亮度、背景颜色等。支持横屏和竖屏两种阅读方式，大屏设备体验更佳。',
      '书架管理：收藏喜欢的漫画后，它们会自动出现在你的书架中。你可以创建自定义分类文件夹，按阅读进度、喜爱程度等方式整理你的漫画收藏。',
      '离线下载：对于网络不稳定的场景，禁漫天支持漫画章节离线下载功能。下载后的内容可以在无网络环境下阅读，是通勤和旅行的好帮手。',
      '评论互动：每部漫画都有专属的评论区，你可以在这里与其他读者交流心得、讨论剧情。友善的社区氛围让阅读不再孤单。',
      '此外，禁漫天还提供个性化推荐、更新提醒、阅读历史记录等贴心功能，全方位提升你的漫画阅读体验。',
    ],
    author: '禁漫天编辑部',
    publishDate: '2026-08-04',
    updateDate: '2026-08-07',
    tags: ['禁漫天使用教程', '功能介绍', '阅读技巧', '平台指南'],
    views: 65430,
    rating: 4.5,
  },
  {
    id: '5',
    title: '禁漫天常见问题汇总 - 你想知道的都在这里',
    slug: 'changjian-wenti',
    category: '使用指南',
    categorySlug: 'shiyong-zhinan',
    coverImage: 'https://readdy.ai/api/search-image?query=FAQ%20help%20center%20interface%20with%20manga%20theme%2C%20friendly%20customer%20support%20design%2C%20colorful%20question%20mark%20icons%2C%20warm%20and%20approachable%20aesthetic%2C%20anime%20style%20decorative%20elements%2C%20clean%20organized%20layout%2C%20professional%20help%20desk%20design%2C%20soft%20pastel%20color%20scheme&width=800&height=450&seq=manga-faq-guide&orientation=landscape',
    description: '收集整理了禁漫天用户最常遇到的问题及详细解答，包括访问问题、账号问题、阅读问题、付费问题等，一站式解决你的所有疑问。',
    content: [
      '为了帮助用户更好地使用禁漫天，我们整理了以下常见问题及详细解答。如果你遇到的问题不在列表中，欢迎通过关于我们页面的联系方式反馈。',
      '访问相关：为什么有时候打不开禁漫天？这通常是由于网络波动或浏览器缓存导致。建议尝试清除浏览器缓存、更换网络环境或使用其他浏览器访问。如果问题持续，可能是入口地址已更新，请查阅本站最新入口信息。',
      '账号相关：账号被盗了怎么办？请立即通过"忘记密码"功能重置密码，并检查绑定的手机号和邮箱是否被修改。建议开启二次验证功能增强账号安全性。',
      '阅读相关：阅读时加载很慢怎么办？可以尝试切换网络、降低图片质量设置，或使用离线下载功能提前缓存内容。',
      '付费相关：禁漫天的大部分内容都是免费阅读的。部分独家内容可能需要会员权限。会员价格和权益详情请在平台内查看。',
      '其他问题：如果你有其他疑问，欢迎联系禁漫天官方客服。我们会尽快为你解决问题。',
    ],
    author: '禁漫天编辑部',
    publishDate: '2026-08-05',
    updateDate: '2026-08-08',
    tags: ['禁漫天常见问题', 'FAQ', '问题解答', '帮助中心'],
    views: 123400,
    rating: 4.9,
  },
  {
    id: '6',
    title: '禁漫天2026年最新热门漫画推荐 - 不容错过的佳作',
    slug: 'remen-manhua-tuijian',
    category: '内容导览',
    categorySlug: 'neirong-daolan',
    coverImage: 'https://readdy.ai/api/search-image?query=Top%20trending%20manga%20book%20covers%20displayed%20in%20a%20beautiful%20arrangement%2C%20colorful%20Japanese%20comic%20covers%20with%20vibrant%20art%2C%20warm%20gallery%20lighting%2C%20professional%20bookstore%20display%2C%20best%20selling%20comics%20collection%2C%20clean%20modern%20layout%2C%20anime%20art%20style%20showcase&width=800&height=450&seq=hot-manga-recommendations&orientation=landscape',
    description: '2026年禁漫天上最受欢迎的漫画推荐榜单，涵盖各大分类的优质作品。无论你喜欢什么类型，这份推荐列表都值得一看。',
    content: [
      '2026年已经过半，禁漫天上涌现了大量优秀的漫画作品。我们根据阅读量、评分和用户口碑，精选了各分类中最值得一看的漫画推荐给大家。',
      '热血冒险推荐：《星辰勇士》讲述少年在宇宙冒险中不断成长的故事，画风精美、剧情紧凑。《烈焰之心》以独特的火焰战斗系统闻名，战斗场面极具视觉冲击力。',
      '恋爱校园推荐：《樱花下的约定》描绘了一段跨越十年的纯爱故事，细腻的情感刻画让无数读者落泪。《同桌的你》则是一部轻松搞笑的校园恋爱喜剧，轻松愉快。',
      '悬疑推理推荐：《暗夜追踪者》以其环环相扣的剧情和出人意料的结局征服了大量读者。《密室之謎》则是一部精心设计的密室逃脱题材漫画，烧脑程度满分。',
      '搞笑日常推荐：《废柴逆袭记》讲述了一个普通高中生的爆笑日常，夸张的表情和诙谐的对白让人忍俊不禁。《猫咪咖啡厅》以可爱猫咪为主角，温馨治愈又笑料不断。',
      '以上只是禁漫天海量优质漫画中的一小部分，更多精彩内容等待你的发现。打开禁漫天，开启你的漫画之旅吧！',
    ],
    author: '禁漫天编辑部',
    publishDate: '2026-07-28',
    updateDate: '2026-08-06',
    tags: ['漫画推荐', '热门漫画', '禁漫天推荐', '2026漫画'],
    views: 210500,
    rating: 4.8,
  },
  {
    id: '7',
    title: '禁漫天平台安全性解析 - 放心畅读每一页',
    slug: 'pingtai-anquanxing',
    category: '使用指南',
    categorySlug: 'shiyong-zhinan',
    coverImage: 'https://readdy.ai/api/search-image?query=Digital%20security%20shield%20concept%20with%20manga%20theme%2C%20safe%20browsing%20illustration%2C%20lock%20icon%20with%20anime%20style%2C%20modern%20cybersecurity%20design%20with%20warm%20colors%2C%20professional%20tech%20aesthetic%2C%20clean%20interface%2C%20trustworthy%20and%20reliable%20visual&width=800&height=450&seq=manga-security-guide&orientation=landscape',
    description: '关于禁漫天平台的安全性，本文从技术架构、数据加密、隐私保护等多个角度进行全面解析，让你放心使用禁漫天的各项服务。',
    content: [
      '用户的信息安全和隐私保护是禁漫天最重视的方面之一。我们采用行业领先的安全技术，全方位保障用户的数据安全。',
      '数据加密：禁漫天平台采用HTTPS加密传输协议，所有用户数据在传输过程中都经过高强度加密处理，有效防止数据被窃取或篡改。',
      '账号保护：平台支持多种账号保护机制，包括登录验证、异常登录提醒、设备管理等。建议用户开启所有可用的安全保护功能，最大程度保障账号安全。',
      '隐私保护：禁漫天严格遵守相关法律法规，承诺不会将用户个人信息泄露给第三方。用户可以随时在设置中查看和管理自己的隐私权限。',
      '内容审核：平台设有专业的内容审核团队，确保所有上架的漫画内容符合法律法规要求，为用户提供健康、积极的阅读环境。',
      '我们持续投入资源优化安全体系，让每一位用户都能在禁漫天上安心阅读、放心畅享。如有任何安全方面的疑问，欢迎随时联系我们。',
    ],
    author: '禁漫天编辑部',
    publishDate: '2026-07-30',
    updateDate: '2026-08-05',
    tags: ['禁漫天安全', '隐私保护', '数据加密', '平台安全'],
    views: 45320,
    rating: 4.6,
  },
  {
    id: '8',
    title: '禁漫天社区互动指南 - 找到志同道合的漫友',
    slug: 'shequ-hudong-zhinan',
    category: '内容导览',
    categorySlug: 'neirong-daolan',
    coverImage: 'https://readdy.ai/api/search-image?query=Friendly%20online%20community%20with%20manga%20theme%2C%20people%20connecting%20through%20anime%20and%20comics%2C%20colorful%20social%20interaction%20design%2C%20warm%20and%20welcoming%20atmosphere%2C%20modern%20social%20platform%20interface%2C%20Japanese%20pop%20culture%20aesthetic%2C%20vibrant%20community%20space&width=800&height=450&seq=manga-community-guide&orientation=landscape',
    description: '禁漫天不仅是漫画阅读平台，更是一个充满活力的漫画社区。本文带你了解如何在禁漫天上与百万漫友互动交流，分享阅读心得。',
    content: [
      '禁漫天的社区是平台最具活力的部分之一。在这里，你可以与来自全国各地的漫画爱好者交流心得、讨论剧情、分享收藏。',
      '评论区互动：每部漫画都有专属的评论区，你可以在这里发表对剧情的看法、预测后续发展，或者与其他读者讨论角色。友善、有见地的评论往往会获得大量点赞。',
      '圈子功能：禁漫天的圈子功能允许用户根据兴趣创建或加入不同主题的讨论组。无论是特定漫画的粉丝圈，还是某一类型的爱好者群组，都能在这里找到归属。',
      '创作分享：如果你有绘画或写作才华，禁漫天的创作区是你展示作品的舞台。许多优秀的同人作品都在这里诞生，并获得大量粉丝的关注和支持。',
      '活动参与：平台定期举办各类线上活动，如漫画知识竞赛、角色人气投票、新作试读等。参与活动不仅有趣，还有机会赢取精美周边奖品。',
      '禁漫天的社区氛围以友善、尊重为核心。我们倡导理性讨论，反对引战和人身攻击。让我们共同维护这个美好的漫画爱好者家园。',
    ],
    author: '禁漫天编辑部',
    publishDate: '2026-07-25',
    updateDate: '2026-08-04',
    tags: ['禁漫天社区', '漫画社区', '漫友交流', '互动指南'],
    views: 38900,
    rating: 4.4,
  },
];

export const faqItems: FAQItem[] = [
  {
    question: '禁漫天的官方入口地址是什么？',
    answer: '禁漫天的官方入口地址会定期更新以确保用户能够稳定访问。最新的官方入口地址请查看本站首页的"官方入口"板块，或关注禁漫天官方社交媒体账号获取实时更新。建议将本站加入收藏夹以便随时获取最新地址。',
  },
  {
    question: '如何在禁漫天上注册账号？',
    answer: '注册禁漫天账号非常简单：访问禁漫天官方入口后，点击"注册"按钮，选择手机号注册或邮箱注册，填写相关信息并完成验证即可。注册成功后建议立即完善个人资料并绑定安全手机号和邮箱。详细教程请参考本站的注册登录指南。',
  },
  {
    question: '禁漫天上的漫画都是免费的吗？',
    answer: '禁漫天上大部分漫画内容都是免费阅读的。平台采用广告+免费的模式为读者提供服务。部分精品独家内容可能需要开通会员才能阅读，会员价格和权益详情请在平台内查看。',
  },
  {
    question: '为什么有时候打不开禁漫天？',
    answer: '打不开禁漫天可能有以下几种原因：1）网络波动或不稳定；2）浏览器缓存问题，建议清除缓存后重试；3）入口地址已更新，请查看本站获取最新地址；4）部分地区网络限制，建议切换网络环境。如果问题持续存在，请联系禁漫天客服。',
  },
  {
    question: '禁漫天支持离线下载吗？',
    answer: '是的，禁漫天支持漫画章节的离线下载功能。在WiFi环境下提前下载想看的漫画，即使在没有网络的情况下也能畅快阅读。下载的漫画内容会保存在APP本地存储中，可以通过设置管理下载内容和存储空间。',
  },
  {
    question: '忘记账号密码怎么办？',
    answer: '如果忘记了禁漫天的登录密码，可以在登录页面点击"忘记密码"，通过绑定的手机号或邮箱接收验证码后重置密码。如果绑定的手机号或邮箱已不再使用，请联系禁漫天客服协助处理。',
  },
  {
    question: '禁漫天上可以发表评论吗？',
    answer: '当然可以！禁漫天鼓励读者在每部漫画下发表评论和读后感。评论需要遵守社区规范，保持友善和尊重。优质的评论会获得其他读者的点赞和回复，活跃的评论者还有机会获得平台的特殊标识和奖励。',
  },
  {
    question: '如何联系禁漫天官方客服？',
    answer: '你可以通过以下方式联系禁漫天官方客服：1）在APP或网站内使用在线客服功能；2）发送邮件至官方客服邮箱；3）通过禁漫天官方社交媒体账号私信联系。客服工作时间一般为每天9:00至21:00，我们会尽快回复你的问题。',
  },
];

export const brandInfo = {
  name: '禁漫天',
  founded: '2018年',
  description: '禁漫天是国内领先的漫画阅读平台，自2018年成立以来，始终致力于为漫画爱好者提供海量优质的正版漫画资源和流畅舒适的阅读体验。平台汇聚了来自全球的优秀漫画作品，涵盖热血冒险、恋爱校园、悬疑推理、搞笑日常、科幻奇幻、古风武侠、恐怖灵异和治愈温馨等多种类型，满足不同读者的阅读喜好。',
  mission: '让每一个人都能轻松享受漫画的乐趣',
  values: ['用户至上', '内容为王', '安全可靠', '持续创新'],
  achievements: [
    { label: '注册用户', value: '5000万+' },
    { label: '漫画资源', value: '10万+部' },
    { label: '日均阅读', value: '3000万+次' },
    { label: '用户好评率', value: '98.6%' },
  ],
  testimonials: [
    {
      name: '小王',
      role: '大学生',
      content: '禁漫天是我每天必刷的漫画平台！资源超全，更新速度也很快，再也不用到处找漫画了。离线下载功能简直是通勤神器！',
      rating: 5,
    },
    {
      name: '阿琳',
      role: '上班族',
      content: '用了禁漫天三年了，从学生时代到现在工作，一直都在用。画质清晰，分类齐全，推荐的算法也很准，总能发现好看的漫画。',
      rating: 5,
    },
    {
      name: '老张',
      role: '漫画爱好者',
      content: '作为一个看漫画十几年的老漫迷，禁漫天的阅读体验是我见过最好的。社区的讨论氛围也很好，认识了很多志同道合的朋友。',
      rating: 5,
    },
  ],
  contact: {
    email: 'support@jinmantian.com',
    weibo: '@禁漫天官方',
    wechat: '禁漫天官方公众号',
    hours: '周一至周日 9:00 - 21:00',
    address: '中国',
  },
};